import styles from './staticChannelCardStrip.module.scss';
import IconAudioPlayButtonFilledShadow from '@/assets/icons/icon-audio-play-button-filled-shadow.svg';
import SXMLink from '@/shared-components/SXMLink';
import ImageWrapper from '@/shared-components/ImageWrapper/ImageWrapper';
import cn from 'classnames';

export interface StaticChannelCardStripProps {
    radioImageUrl: string;
    radioImageAlt?: string;
    listenLink: string;
    listenLinkAriaLabel?: string;
    borderColor: string;
    bannerText?: string;
    disableShadow?: boolean;
}

export default function StaticChannelCardStrip({
    listenLink,
    listenLinkAriaLabel = 'listen link',
    borderColor,
    radioImageUrl,
    radioImageAlt = 'channel image',
    bannerText,
    disableShadow,
}: StaticChannelCardStripProps) {
    const style: React.CSSProperties = {
        ...({ '--border-color': borderColor } as React.CSSProperties),
    };

    const BannerHtml = <div className={styles.bannerContainer}>{bannerText ? bannerText : ''}</div>;

    return (
        <SXMLink
            style={style}
            href={listenLink}
            aria-label={listenLinkAriaLabel}
            className={styles.contentContainer}
            data-player-link={''}
        >
            <div className={cn(styles.wrapper, { [styles.disableShadow]: disableShadow })}>
                <div className={styles.imageContainer}>
                    <div className={styles.radioImage}>
                        <ImageWrapper
                            optimizedWidth={120}
                            optimizedHeight={60}
                            src={radioImageUrl}
                            alt={radioImageAlt}
                        />
                    </div>
                </div>

                <div className={styles.colorBorder}>
                    <div className={styles.listenLiveText}>listen live</div>
                    <IconAudioPlayButtonFilledShadow className={styles.playIcon} />
                    <div className={styles.borderBackground} style={style} />
                </div>
            </div>
            {bannerText && BannerHtml}
        </SXMLink>
    );
}
